module.exports = __webpack_public_path__ + "img/number_transaction.80c20bb.png";